// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from 'styled-components';

import { token } from '@atlaskit/tokens';

interface SpinnerWrapperProps {
	height?: number | string;
}

const getHeight = ({ height }: SpinnerWrapperProps) => {
	if (typeof height === 'number') {
		return `${height}px`;
	}
	return height;
};

// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const SpinnerWrapper = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	margin: ${token('space.200', '16px')} 0;
	height: ${getHeight};
`;
